import PlayerPosition from "./player-position";

const PositionPref = Object.freeze({
    PASS: [
        PlayerPosition.QUARTERBACK,
        PlayerPosition.RUNNING_BACK,
        PlayerPosition.FULLBACK,
        PlayerPosition.SLOT_BACK,
        PlayerPosition.WIDE_RECEIVER,
        PlayerPosition.TIGHT_END
    ],
    RUSH: [
        PlayerPosition.RUNNING_BACK,
        PlayerPosition.FULLBACK,
        PlayerPosition.SLOT_BACK,
        PlayerPosition.QUARTERBACK,
        PlayerPosition.WIDE_RECEIVER,
        PlayerPosition.TIGHT_END
    ],
    RECEPTION: [
        PlayerPosition.WIDE_RECEIVER,
        PlayerPosition.TIGHT_END,
        PlayerPosition.RUNNING_BACK,
        PlayerPosition.FULLBACK,
        PlayerPosition.SLOT_BACK,
        PlayerPosition.QUARTERBACK
    ],
    PASS_TACKLE: [
        PlayerPosition.CORNER_BACK,
        PlayerPosition.SAFETY,
        PlayerPosition.FREE_SAFETY,
        PlayerPosition.STRONG_SAFETY,
        PlayerPosition.LINEBACKER,
        PlayerPosition.INSIDE_LINEBACKER,
        PlayerPosition.MIDDLE_LINEBACKER,
        PlayerPosition.OUTSIDE_LINEBACKER,
        PlayerPosition.LEFT_OUTSIDE_LINEBACKER,
        PlayerPosition.RIGHT_OUTSIDE_LINEBACKER,
        PlayerPosition.DEFENSIVE_END,
        PlayerPosition.DEFENSIVE_LINE
    ],
    RUSH_TACKLE: [
        PlayerPosition.DEFENSIVE_LINE,
        PlayerPosition.DEFENSIVE_END,
        PlayerPosition.LINEBACKER,
        PlayerPosition.INSIDE_LINEBACKER,
        PlayerPosition.MIDDLE_LINEBACKER,
        PlayerPosition.OUTSIDE_LINEBACKER,
        PlayerPosition.LEFT_OUTSIDE_LINEBACKER,
        PlayerPosition.RIGHT_OUTSIDE_LINEBACKER,
        PlayerPosition.CORNER_BACK,
        PlayerPosition.SAFETY,
        PlayerPosition.FREE_SAFETY,
        PlayerPosition.STRONG_SAFETY
    ],
    DEFENSE: [
        PlayerPosition.CORNER_BACK,
        PlayerPosition.SAFETY,
        PlayerPosition.FREE_SAFETY,
        PlayerPosition.STRONG_SAFETY,
        PlayerPosition.LINEBACKER,
        PlayerPosition.INSIDE_LINEBACKER,
        PlayerPosition.MIDDLE_LINEBACKER,
        PlayerPosition.OUTSIDE_LINEBACKER,
        PlayerPosition.LEFT_OUTSIDE_LINEBACKER,
        PlayerPosition.RIGHT_OUTSIDE_LINEBACKER,
        PlayerPosition.DEFENSIVE_END,
        PlayerPosition.DEFENSIVE_LINE
    ],
    KICK: [PlayerPosition.KICKER],
    PUNT: [PlayerPosition.PUNTER],
    RETURNER_KICKOFF: [PlayerPosition.KICK_RETURNER],
    RETURNER_PUNT: [PlayerPosition.PUNT_RETURNER]
});

export default PositionPref;
